"use client";

import ErrorState from "@/components/general/error-state";
import SpaPageBackground from "@/components/spa/general/spa-page-background";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="relative flex min-h-screen items-center justify-center px-6 py-12">
      <SpaPageBackground />
      <div className="relative z-10 w-full max-w-lg">
        <ErrorState
          title="Something went wrong"
          description="An unexpected problem occurred. Please try again. If this keeps happening, contact support."
          context="generic"
          actionLabel="Try again"
          onAction={reset}
        />
      </div>
    </div>
  );
}
